export const thailand = {
  translation: {
    // ================================= titles =================================
    titles: {
      popular_add_ons: 'Popular add-ons',
      top: 'ด้านบน',
      hello: 'สวัสดีค่ะ',
      in_your_cart: 'รถเข็นคำสั่งซื้อของคุณ',
      search_result: 'ผลการค้นหา',
      no_items_found: 'พบ 0 รายการ',
      search_empty: 'ไม่มีการแสดงข้อมูล',
      call_staff: 'ได้รับคำสั่งเรียกพนักงาน',
      sub_total: 'ผลรวมยอดย่อย',
      total: 'ผลรวมทั้งหมด',
      order_details: 'ข้อมูลคำสั่งซื้อ',
      popup_pay: 'ต้องการชำระเงินเลยไหมคะ？',
      payment_success: 'ได้รับคำสั่งเรียกเก็บเงิน',
      order_empty: 'ไม่มีการสั่งซื้อ',
      pending: 'หยุดรอดำเนินการ',
      served: 'ยืนยันแล้ว',
      confirmed: 'ยืนยันแล้ว',
      finish_cooking: 'เตรียมอาหารเสร็จแล้ว',
      cancelled: 'ยกเลิกแล้ว',
      ready_to_order: 'สั่งเลยไหมคะ？',
      order_success: 'เราได้รับคำสั่งซื้อของคุณแล้ว',
      maxQuantityPerOrder: 'จำนวนการสั่งซื้อสูงสุดต่อการสั่งซื้อ1ครั้ง',
      topping_type_quantity: '{{min}}มากกว่า - {{max}}น้อยกว่า',
      menu_excludes_vat: 'ราคานี้ยังไม่รวมภาษีมูลค่าเพิ่ม',
      rescanQR: 'กรุณาสแกนคิวอาร์โค้ดอีกครั้ง',
      choose_language_to_start: 'เลือกภาษาของคุณตอนนี้',
      customizedService: 'บริการที่กำหนดเองสำหรับคุณ',
      selectOption: 'โปรดเลือกตัวเลือก',
      call_staff_reasons: 'โทรแจ้งเจ้าหน้าที่',
      choose_payment_method: 'กรุณาเลือกวิธีการชำระเงิน',
      payment_successfully: 'ชำระเงินเรียบร้อย',
      payment_failed: 'การชำระเงินล้มเหลว',
      how_was_your_experience: 'ประสบการณ์ของคุณเป็นอย่างไรบ้าง?',
      your_details: 'รายละเอียด',
      how_many_people: 'คุณมีกี่คน?',
      please_select_number_of_people: '*กรุณาเลือกจำนวนคนรวมถึงทารกด้วย.',
      choose_number_of_people: 'โปรดเลือกจำนวนที่นั่งในโต๊ะของคุณ',
      buffet: 'บุฟเฟต์',
      order_placed: 'สั่งซื้อ',
      order_code: 'รหัสออเดอร์',
      review_order: 'เขียนรีวิวให้พวกเราได้ที่นี้',
      popular: 'ยอดนิยม',
      review_success: 'ขอบคุณมากค่ะ!',
      hope_you_enjoyed: 'หวังว่าคุณจะเพลิดเพลิน.',
      popup_food_error_order:
        'เมนู <span style="font-weight:{{fontWeight}}">{{nameFood}}</span> หมด!',
      popup_topping_error_order:
        'The topping <span style="font-weight:{{fontWeight}}">{{nameTopping}}</span> out of stock!',
      input_a_name: 'กรุณากรอกชื่อ',
      input_a_phone: 'โปรดใส่เบอร์โทรศัพท์',
      why_we_need_it: 'ทำไมเราถึงต้องการมัน',
      discount: 'ส่วนลด',
      // tablet
      search: 'ค้นหา',
      call_staff_tablet: 'เรียกพนักงาน',
      bill: 'บิล',
      pay: 'จ่ายเงิน',
      table_number: 'หมายเลขโต๊ะ:',
      ask_for_bill: 'ขอใบเสร็จ',
      ask_for_bill_decription: 'แตะที่ "ขอใบเสร็จ" เพื่อทำการชำระเงิน',
      not_yet: 'ยังไม่',
      quantity: 'จำนวน',
      item_table: 'สินค้า',
      status_table: 'สถานะ',
      price_table: 'ราคา',
      other: 'อื่นๆ',
    },
    // ================================= descriptions =================================
    descriptions: {
      reached_end: 'เสร็จเรียบร้อย',
      cart_empty: 'รถเข็นคำสั่งซื้อของคุณว่าง',
      hint_cart_empty: 'คลิ๊กเพื่อดูเมนู',
      search_empty: 'คำค้นหาผิดพลาด โปรดพิมพ์อีกครั้ง',
      call_staff: 'กรุณารอสักครู่ พนักงานกำลังจะมา',
      popup_pay: 'กรุณากดปุ่ม「คำขอเรียกเก็บเงิน」พนักงานจะนำใบเสร็จมาให้',
      payment_success: 'รอสักครู่นะคะ',
      restaurant_on_capichi:
        'อาหารของเราสามารถสั่งได้จากแอป <span style="color:{{colorText}}">Capichi</span>',
      order_empty: 'เลือกอาหารที่ชื่นชอบและเพิ่มคำสั่งซื้อของคุณ',
      orderNotFound: 'ไม่พบคำสั่งซื้อ',
      order_success: 'ตอนนี้อยู่ระหว่างจัดเตรียมจนกว่าจะมาบริการโปรดรอสักครู่',
      rescanQR: 'ขออภัย เนื่องจากการชำระเงินครั้งก่อนเสร็จสิ้นแล้ว กรุณาสเเกนคิวอาร์โค้ดอีกครั้ง',
      order_food_and_drink: 'สั่งอาหารและเครื่องดื่มได้ตลอดเวลาที่คุณต้องการ',
      seek_for_help: 'ขอความช่วยเหลือจากเจ้าหน้าที่โดยตรงทางออนไลน์',
      ask_to_pay: 'ขอให้จ่ายเงินเมื่อคุณกินเสร็จ',
      or_ask_directly: 'หรือสอบถามโดยตรง',
      haveVAT: 'ยังไม่รวมภาษีมูลค่าเพิ่ม {{vatRate}}%',
      haveServiceFee: 'ค่าบริการ {{serviceRate}}%',
      popup_payment_success:
        'ยืนยันการชำระเงินออนไลน์ของคุณแล้ว เราขอขอบคุณที่เลือกเราในวันนี้ และหวังว่าคุณจะมีช่วงเวลาและประสบการณ์ที่ยอดเยี่ยม',
      popup_payment_failed:
        'การชำระเงินไม่สำเร็จเนื่องจากเกิดความผิดปกติ โปรดลองอีกครั้งในภายหลังหรือใช้วิธีการชำระเงินอื่นๆ',
      tap_to_save_screen: 'แสดงหน้านี้ให้พนักงานที่ร้าน',
      checkouted_order: `ขอบคุณที่เลือกเราในวันนี้สำหรับมื้ออาหารของคุณ,หวังว่าคุณจะชอบการใช้เวลากับเรา.
      พวกเราจะรู้สึกทราบซึ้งใจอย่างยิ่ง ถ้าหากคุณสามารถแบ่งปันประสบการณ์ของคุณข้างล่างนี้ เพื่อที่เราจะสามารถเติบโตและพัฒนาร้านของเราต่อไป.`,
      review_success:
        'ได้รับการรีวิวของคุณเรียบร้อยแล้ว ทางเราจะนำไปพิจารณาเพื่อการพัฒนาต่อไป การรีวิวของคุณมีประโยชน์กับพวกเรามาก!',
      input_a_name:
        'ขณะนี้คุณกำลังสั่งซื้อจากโต๊ะที่มีคำสั่งซื้อที่แตกต่างกัน เพื่อให้แน่ใจว่าเราแยกคำสั่งซื้อได้อย่างถูกต้อง โปรดป้อนชื่อที่เรียบง่าย* เพื่อระบุคำสั่งซื้อของคุณ',
      input_a_phone:
        'เพื่อที่ทางบริษัทจะสามารถส่งข้อความถึงคุณ แจ้ง ติดตามคำสั่งซื้อของคุณเมื่อคุณสั่งซื้อสำเร็จ',
      min_left: 'อาหารและเครื่องดื่มไม่อั้น {{min_left}} นาทีจากเมนูต่อไปนี้',
    },
    // ================================= actions =================================
    actions: {
      call_staff: 'เรียกพนักงาน',
      pay: 'คิดเงิน',
      back_to_top: 'กลับไปยังหน้าบนสุด',
      order: 'สั่งอาหาร',
      go_back: 'ย้อนกลับ',
      see_menu: 'ดูเมนู',
      order_now: 'สั่งอาหารตอนนี้',
      clear_all: 'ลบทั้งหมด',
      search_again: 'ค้นหาอีกครั้ง',
      retry: 'ลองอีกครั้ง',
      back_to_menu: 'กลับไปยังหน้าเมนู',
      ask_for_bill: 'คำขอเรียกเก็บเงิน',
      not_yet: 'ยกเลิก',
      discover: 'ดาวน์โหลดแอพ',
      delete_dish: 'ลบ',
      noteFood: 'เพิ่มคำข้อพิเศษอื่นๆ',
      addToCart: 'เพิ่มใส่รถเข็น',
      addNote: 'บันทึกเพิ่มเติม',
      confirmOrder: 'ยืนยันคำสั่งซื้อ',
      start_ordering: 'เริ่มสั่งซื้อ',
      pay_online: 'ชำำระออนไลน์',
      send: 'ส่ง',
      try_again: 'ลองอีกครั้ง',
      call_staff_for_help: 'โทรหาเจ้าหน้าที่เพื่อขอความช่วยเหลือ',
      skip: 'ข้าม',
      next: 'ุถัดไป',
      done: 'เสร็จสิ้น',
      confirm: 'ยืนยัน',
      order_from_here: 'สั่งอาหารได้ที่นี่',
      tap_to_save_screen: 'แตะเพื่อบันทึกหน้าจอ',
      see_a_menu: 'ดูเมนู',
      update: 'Update',
      cancel: 'ยกเลิก',
      add: 'เพิ่ม',
      ok: 'โอเค',
      see_the_time: 'ดูเวลา',
    },
    // ================================= errors =================================
    errors: {
      server_error: 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
      errorOutOfStock: 'ขออภัย รายการเหล่านี้ขายหมดแล้ว คุณสามารถเลือกรายการอื่นได้หรือไม่?',
      errorQuantityPerOrder:
        'คุณมีรายการถึงจำนวนสูงสุดที่สามารถเลือกได้เเล้ว ดังนั้นจึงไม่สามารถเพิ่มจำนวนได้อีก',
      errorQuantityExceeded:
        'ขออภัยปริมาณในสต๊อกไม่เพียงพอต่อการสั่งซื้อของคุณ คุณสามารถแก้ไขปริมาณการสั่งซื้อได้หรือไม่？',
      somethingWrong: 'มีข้อผิดพลาดบางอย่าง กรุณาลองอีกครั้ง',
      errorFoodHasChanged:
        'ขออภัย ทางร้านได้มีการปรับเปลี่ยนข้อมูลสินค้า ดังนั้นโปรดทำการสั่งซื้อใหม่อีกครั้ง',
      warningMin: 'ต้องเลือกอย่างน้อย {{min}} รายการสำหรับท็อปปิ้งนี้',
      warningMax: 'คุณสามารถเลือกท็อปปิ้งนี้ได้สูงสุด {{max}}เท่านั้น',
      notFoundFoodItem:
        'ขออภัย ทางร้านงดให้บริการอาหารจานนี้ชั่วคราว กรุณาลองใหม่อีกครั้งในภายหลัง.',
      errorNotOpenTable:
        'โต๊ะของคุณยังไม่เปิดใช้งานอีกต่อไป โปรดโทรหาพนักงานเพื่อขอความช่วยเหลือค่ะ',
      max_comment_review: 'สูงสุด {{max}} ตัวอักษร',
      payment_method_changed: 'เปลี่ยนวิธีการชำระเงินแล้ว',
      payment_method_changed_desc: 'โปรดรีเฟรชหน้านี้และเลือกวิธีการชำระเงินของคุณอีกครั้ง',
      max_characters: 'พิมพ์ไม่เกิน{{max}}ตัวอักษร',
      required_floor: 'ระบุชั้น',
      required_room: 'ระบุห้อง',
      required_full_name: 'ระบุชื่อเต็ม',
      errorOutOfStockNEC: 'สินค้าหมด',
      rating_already_existed: 'ขออภัย ออเดอร์นี้ได้ให้การประเมินแล้ว',
      voucher_not_suitable: 'รหัสคูปองไม่เหมาะสม กรุณาลองอีกครั้ง',
      error: 'เกิดข้อผิดพลาด',
      voucher_not_found: 'ไม่มีรหัสบัตรกำนัล โปรดลองใช้รหัสอื่น',
      voucher_outside_time_period: 'รหัสบัตรกำนัลไม่ถูกต้องหรือหมดอายุแล้ว โปรดลองใช้รหัสอื่น',
      voucher_just_apply_for_restaurants: 'รหัสบัตรกำนัลใช้ได้กับ: {{restaurants}} เท่านั้น',
      voucher_min_order_value: 'รหัสบัตรกำนัลใช้ได้กับการสั่งซื้อตั้งแต่ {{min_order_value}}',
      voucher_has_been_used: 'รหัสบัตรกำนัลถูกใช้แล้ว',
      voucher_out_of_quantity: 'โค้ดส่วนลดนี้เต็มแล้ว กรุณาลองใช้โค้ดส่วนลดอื่น',
      min_max_phone_number: 'กรุณากรอกหมายเลขโทรศัพท์ระหว่าง {{min}}-{{max}} ตัวอักษร',
    },
    // ================================= languages =================================
    languages: {},
    // ================================= label =================================
    label: {
      zezoYen: '0 yen',
      required: 'Required',
      optional: 'Optional',
      my_cart: 'รถเข็น',
      items_found: 'พบรายการที่ตรงกัน',
      sold_out: 'ขายหมดเเล้ว',
      items: 'หัวข้อรายการ',
      powered_by: 'Powered by',
      vat: 'VAT',
      service_fee: 'ค่าบริการ',
      your_order: 'คำสั่งซื้อ',
      or: 'หรือ',
      payment_methods: {
        international_card: 'บัตรเครดิต',
        atm: 'เอทีเอ็ม',
        qr_code: 'การโอนโดยคิวอาร์',
        e_wallet: 'อี-วอลเล็ท',
      },
      review_or_comment: 'โปรดแสดงความคิดเห็นหรือให้คำแนะนำกับเรา',
      only_letters: 'กรอกเฉพาะตัวหนังสือเท่านั้น',
      buffet: 'บุฟเฟ่ต์',
      min_left: 'เหลืออีก <strong style="color:{{color}}">{{min_left}}</strong> นาที',
      all_you_can_drink: 'ดื่มไม่จำกัด',
    },
    // ================================= placeholder =================================
    placeholder: {
      input_search: 'ค้นหาอาหาร เมนู และเครื่องดื่ม...',
      choose_your_floor: 'เลือกชั้น',
      choose_your_room: 'เลือกห้อง',
      your_full_name: 'ชื่อเต็ม',
      no_results: 'ไม่มีผลลัพธ์',
      your_name: 'ชื่อของคุณ',
      enter_voucher_code: 'กรอกรหัสบัตรกำนัล',
      your_phone: 'หมายเลขโทรศัพท์ของคุณ',
    },
    popup_start_buffet: {
      course_menu_has_started: 'เมนูคอร์สได้เริ่มแล้ว',
      time_limit: 'จำกัดเวลา',
      time_value: '{{value}} นาที',
      see_menu: 'ดูเมนู',
    },
    popup_add_friend_line: {
      line: 'LINE',
      description: 'โปรดเพิ่มเราเป็นเพื่อนใน LINE เพื่อใช้บริการสั่งซื้อผ่านมือถือ',
      add_friend_btn: 'เพิ่มเป็นเพื่อนใน LINE',
      already_added: 'เพิ่มเป็นเพื่อนแล้ว',
    },
  },
}
